export default __webpack_public_path__ + "static/media/cardPhoto.0f546a48.png";